import { COUNTRIES_DATA, STATES_DATA } from '@/config/countriesData';

export const transformCountryLabelToValue = (countryLabel: string): string => {
  if (!countryLabel) return '';

  const normalizedLabel = countryLabel.trim().toLowerCase();

  return (
    COUNTRIES_DATA.find(
      (country) => country.label.toLowerCase() === normalizedLabel || country.name.toLowerCase() === normalizedLabel
    )?.value || countryLabel
  );
};

export const transformStateLabelToValue = (stateLabel: string, countryValue: string): string => {
  if (!stateLabel || !countryValue) return '';

  const normalizedLabel = stateLabel.trim().toLowerCase();
  const states = STATES_DATA[countryValue as keyof typeof STATES_DATA];

  return (states && states?.find((state) => state.label.toLowerCase() === normalizedLabel)?.value) || stateLabel;
};

export const transformCountryValueToLabel = (countryValue: string): string => {
  return COUNTRIES_DATA.find((country) => country.value === countryValue)?.label || countryValue || '';
};

export const transformStateValueToLabel = (stateValue: string, countryValue: string): string => {
  if (!stateValue || !countryValue) return '';

  const states = STATES_DATA[countryValue as keyof typeof STATES_DATA];

  return (states && states?.find((state) => state.value === stateValue)?.label) || stateValue;
};
